module.exports = {
  SM: 350,
  MD: 600,
  LG: 1000,
  XL: 1400,
  XXL: 1650,
}
